import { useContext, useState } from "react";
import { Button, Grid, Modal, TextField } from "@mui/material";
import { renameChat } from "../../../services/Chat";
import { useQueryClient, useMutation } from "react-query";
import { WizardContext } from "../../wizard/Context";
import { useToast } from "../../toast";
import { set } from "date-fns";

const RenameModal = ({ open, setOpen, chatId, chatTitle = "Untitled" }) => {
    const { state, dispatch } = useContext(WizardContext);
    const { chatConfig } = state;
    const queryClient = useQueryClient();
    const { addToast } = useToast();
    const [title, setTitle] = useState(chatTitle);
    
    const { mutate, isLoading } = useMutation(
        renameChat,
        {
            onSuccess: () => {
                queryClient.invalidateQueries("getChats");

                addToast({
                    type: "success",
                    message: `Chat renamed to "${title.trim() || "Untitled"}" successfully.`,
                    autoClose: 2000,
                });

                if(chatConfig?.chatId === chatId) {
                    dispatch({
                        type: "UPDATE_CHAT_WINDOW",
                        payload: {
                            chatConfig: {
                                ...chatConfig,
                                title: title.trim() || "Untitled",
                            },
                        },
                    });
                }

                setOpen(false);
            },

            onError: (error) => {
                addToast({
                    type: "error",
                    message: `Failed to rename chat: ${error?.message || "Unknown error"}`,
                    autoClose: 2000,
                });

                setOpen(false);
            }
        },
    );

    const handleRename = () => {
        mutate({
            chatId,
            title: title.trim() || "Untitled",
        });
    }

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="rename-chat-modal"
            aria-describedby="rename-chat-description"
        >
            <Grid
                sx={{
                    position: 'absolute',
                    padding: "30px",
                    display: 'flex',
                    flexDirection: 'column',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '500px',
                    bgcolor: 'background.paper',
                    borderRadius: "10px",
                    gap: '20px',
                }}
            >
                <TextField
                    variant="outlined"
                    label="Chat Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    multiline
                    maxRows={4}
                    fullWidth
                    autoFocus
                />
                <Grid
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px',
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleRename}
                        disabled={isLoading || title.trim() === chatTitle}
                    >
                        {isLoading ? "Saving..." : "Save"}
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
}

export default RenameModal;
